module.exports = __webpack_public_path__ + "img/reception_fix.7ed4d8fd.jpg";